import React from "react";
import "./footer.css";
import { FaLinkedin } from "react-icons/fa";
import { BsGithub } from "react-icons/bs";
import { IoIosMail } from "react-icons/io";

function Footer() {
  return (
    <footer>
      <a href="#" className="footer_logo">
        Emre Durmus
      </a>

      <ul className="permaLinks">
        <li>
          <a href="#">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Experience</a>
        </li>
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
      </ul>

      <div className="footer__socials">
        <a
          href="https://www.linkedin.com/in/emre-durmus-62670223b/"
          target="_blank"
        >
          {" "}
          <FaLinkedin size={20} />{" "}
        </a>
        <a href="https://github.com/emredurrmus" target="_blank">
          {" "}
          <BsGithub size={20} />{" "}
        </a>
        <a href="mailto:edurrmus@gmail.com" target="_blank">
          {" "}
          <IoIosMail size={20} />{" "}
        </a>
      </div>

      <div className="footer_copyright">
        <small>&copy; Emre Durmus Tutorials. All rights reserved.</small>
      </div>
    </footer>
  );
}

export default Footer;
